import { useState } from 'react';

import { usePreAuthFinePrint } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { EvenSplitIconTypography } from 'reservations/checklessPayments/components/SplitBillIconTypography';
import { CHECKLESS_BILL_SPLITTING_SUBHEADER } from 'reservations/checklessPayments/constants';
import { PaymentForm } from 'reservations/payments/components/PaymentForm';

export const AddCardToSplitLeadModal = () => {
  const [handleSaveCard, setHandleSaveCard] = useState<() => void>(() => {});
  const { open } = useModal();

  const handleClick = async () => {
    await handleSaveCard?.();
    open(ModalType.SelectGratuity, {
      handleSuccess: () =>
        open(ModalType.ManageSplitBill, {
          disableBack: true,
          primaryButtonLabel: 'INVITE TO SPLIT'
        })
    });
  };

  return (
    <BaseDrawer
      header="Add your card to split the bill"
      subheader={CHECKLESS_BILL_SPLITTING_SUBHEADER}
      primaryButton={{ label: 'NEXT', onClick: handleClick }}
      footer={usePreAuthFinePrint()}
      requireAuth
    >
      <EvenSplitIconTypography />
      <PaymentForm setHandleSaveCard={setHandleSaveCard} />
    </BaseDrawer>
  );
};
